
import React from 'react';
import { Dropdown } from 'office-ui-fabric-react/lib/Dropdown';
import get from 'lodash/get';

const SelectAttributes = ({
    attributes,
    label,
    onChange,
    options,
    placeholder,
    readOnly,
    values
}) => {

    const getOptions = () => {
        return attributes.map(item => {
            return {
                key: item.id,
                text: item.title
            };
        });
    }

    const handleChange = (evt, option, index, value) => {
        if (onChange) {
            if (option.selected) {
                onChange([
                    ...values,
                    option.key
                ]);
            } else {
                onChange(values.filter(item => (item !== option.key)));
            }
        }
    }

    return (
        <Dropdown
            disabled={readOnly}
            label={label || 'Atributy'}
            multiSelect
            options={getOptions()}
            onChange={handleChange}
            placeholder={placeholder || 'Vyberte atributy'}
            selectedKeys={values}
            styles={get(options, 'Dropdown.styles')}
        />
    );
}

export default SelectAttributes;
